/* eslint no-shadow: 0 */
export enum Authority {
  DOCTOR = 'MEDICO',
  CONTRACTOR = 'CONTRATANTE',
}
